import { FunctionComponent, SVGProps } from 'react'

export const IconInspect: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  id,
  ...props
}) => {
  const filter0 = `${id}-filter0`
  const filter1 = `${id}-filter1`
  const paint0 = `${id}-paint0`
  const paint1 = `${id}-paint1`

  return (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter={`url(#${filter0})`}>
        <path
          d="M20 11.1842V6.18424C20 5.74222 19.8244 5.31829 19.5118 5.00573C19.1993 4.69317 18.7754 4.51758 18.3333 4.51758H6.66667C6.22464 4.51758 5.80072 4.69317 5.48816 5.00573C5.17559 5.31829 5 5.74222 5 6.18424V17.8509C5 18.2929 5.17559 18.7169 5.48816 19.0294C5.80072 19.342 6.22464 19.5176 6.66667 19.5176H11.6667"
          fill={`url(#${paint0})`}
          shapeRendering="crispEdges"
        />
        <path
          d="M20 11.1842V6.18424C20 5.74222 19.8244 5.31829 19.5118 5.00573C19.1993 4.69317 18.7754 4.51758 18.3333 4.51758H6.66667C6.22464 4.51758 5.80072 4.69317 5.48816 5.00573C5.17559 5.31829 5 5.74222 5 6.18424V17.8509C5 18.2929 5.17559 18.7169 5.48816 19.0294C5.80072 19.342 6.22464 19.5176 6.66667 19.5176H11.6667"
          stroke="#C8F252"
          strokeLinecap="square"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter={`url(#${filter1})`}>
        <path
          d="M12.7166 12.1042C12.635 12.0716 12.554 12.1526 12.5867 12.2342L15.7399 20.1174C15.7735 20.2014 15.8925 20.2012 15.9258 20.1171L17.2341 16.8079C17.2442 16.7822 17.2646 16.7618 17.2903 16.7516L20.5995 15.4434C20.6836 15.4101 20.6839 15.2911 20.5999 15.2575L12.7166 12.1042Z"
          fill={`url(#${paint1})`}
          shapeRendering="crispEdges"
        />
        <path
          d="M12.7166 12.1042C12.635 12.0716 12.554 12.1526 12.5867 12.2342L15.7399 20.1174C15.7735 20.2014 15.8925 20.2012 15.9258 20.1171L17.2341 16.8079C17.2442 16.7822 17.2646 16.7618 17.2903 16.7516L20.5995 15.4434C20.6836 15.4101 20.6839 15.2911 20.5999 15.2575L12.7166 12.1042Z"
          stroke="#C8F252"
          strokeLinecap="square"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id={filter0}
          x="0.5"
          y="0.0175781"
          width="24"
          height="24"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.784314 0 0 0 0 0.94902 0 0 0 0 0.321569 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2175_48893"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2175_48893"
            result="shape"
          />
        </filter>
        <filter
          id={filter1}
          x="8.07812"
          y="7.5957"
          width="17.0859"
          height="17.084"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.784314 0 0 0 0 0.94902 0 0 0 0 0.321569 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2175_48893"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2175_48893"
            result="shape"
          />
        </filter>
        <linearGradient
          id={paint0}
          x1="12.5"
          y1="4.51758"
          x2="12.5"
          y2="19.5176"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#C8F252" stopOpacity="0" />
          <stop offset="1" stopColor="#C8F252" stopOpacity="0.6" />
        </linearGradient>
        <linearGradient
          id={paint1}
          x1="16.6667"
          y1="12.0176"
          x2="16.6667"
          y2="20.3509"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#C8F252" stopOpacity="0" />
          <stop offset="1" stopColor="#C8F252" stopOpacity="0.6" />
        </linearGradient>
      </defs>
    </svg>
  )
}
